import styled from 'styled-components';
import Media from '../../utils/media';
import { Select } from 'antd';

export const TopStyled = styled.div`
  width: 100%;
  min-height: 100vh;
  /* background-image: url('images/top/background.png');
  background-size: 100% 85%;
  background-repeat: no-repeat; */
  position: relative;
  z-index: 9;
  /* background-position: bottom; */

  ${Media.lessThan(Media.SIZE.XL)} {
    content: 'Media.SIZE.XS';

    /* background-size: contain; */
    background-size: 100% 50%;
    background-position: bottom;
    padding: 10px 15px;
  }
`;

export const TopLogoStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .img-logo {
    max-width: 170px;
    max-height: 55px;
    margin-left: 100px;
    margin-top: 42px;
    cursor: pointer;
  }

  .choose-language {
    min-width: 130px;
  }

  ${Media.lessThan(Media.SIZE.XL)} {
    content: 'Media.SIZE.XS';

    .img-logo {
      margin-left: 45px;
      margin-top: 12px;
    }
  }

  ${Media.lessThan(Media.SIZE.MD)} {
    content: 'Media.SIZE.XS';

    .img-logo {
      max-width: 80px;
      max-height: 55px;
      margin-left: 10px;
      margin-top: 12px;
    }
  }
`;

export const SelectLanguageStyled = styled(Select)<any>`
  margin-right: 20px;
  border: none;

  .ant-select-selector {
    border: none !important;
  }

  ${Media.lessThan(Media.SIZE.MD)} {
    margin-right: 0;
  }
`;

export const TopContentStyled = styled.div<{ lang?: string }>`
  margin-left: 100px;
  margin-top: 50px;
  position: relative;
  z-index: 9;
  font-family: ${(props) => (props.lang === 'zh' ? 'Roboto' : 'Inter')};

  .text-1 {
    font-size: 26px;
    font-weight: 500;
  }

  .text-2 {
    margin-top: 15px;
    display: flex;

    .text-2-1 {
      font-size: 48px;
      font-weight: 700;
      color: #00b273;
    }

    .text-2-2 {
      font-size: 48px;
      font-weight: 700;
      margin-left: 15px;
    }
  }

  .text-3 {
    margin-top: 25px;
    font-size: 26px;
    font-weight: 500;
  }

  ${Media.lessThan(Media.SIZE.XL)} {
    content: 'Media.SIZE.XS';

    margin-left: 45px;
    margin-top: 80px;
  }

  ${Media.lessThan(Media.SIZE.MD)} {
    content: 'Media.SIZE.XS';

    margin-left: 10px;
    margin-top: 50px;

    .text-1 {
      font-size: 22px;
      font-weight: 500;
    }

    .text-2 {
      flex-direction: column;

      .text-2-1 {
        font-size: 34px;
        font-weight: 700;
        color: #00b273;
      }

      .text-2-2 {
        text-align: right;
        font-size: 34px;
        font-weight: 700;
        margin-left: 0;
      }
    }

    .text-3 {
      margin-top: 25px;
      font-size: 22px;
      font-weight: 400;

      .hidden-mb {
        display: none;
      }
    }
  }
`;

export const TopChefStyled = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;

  .CHEF {
    max-width: 204px;
    max-height: 296px;
    bottom: 0;
    left: 0;
    margin-left: 100px;
    margin-bottom: 58px;
    position: absolute;
    z-index: 8;
  }

  .BACKGROUND {
    width: 100%;
    height: 100%;
    bottom: 0;
    left: 0;
    position: relative;

    .BG_LINE {
      bottom: 0;
      left: 0;
      position: absolute;
      z-index: 6;
      height: calc(100vh * 30 / 100);
      width: 100%;
      /* height: 50%;
      width: 100%; */
    }

    .BG_DISH {
      bottom: 0;
      right: 0;
      position: absolute;
      z-index: 7;
      height: calc(100vh * 40 / 100);
      margin-right: 150px;
      margin-bottom: 100px;
    }
  }

  ${Media.lessThan(Media.SIZE.XL)} {
    content: 'Media.lessThan(Media.SIZE.XL)';

    .CHEF {
      max-width: calc(204px * 140 / 100);
      max-height: calc(296px * 140 / 100);
      bottom: 0;
      left: 0;
      margin-left: 45px;
      margin-bottom: calc(58px * 140 / 100);
      position: absolute;
    }

    .BACKGROUND {
      width: initial;
      height: initial;
      bottom: 0;
      left: 0;
      position: relative;

      .BG_LINE {
        bottom: 0;
        left: 0;
        position: absolute;
        z-index: 6;
        object-fit: cover;
        height: calc(100vh * 20 / 100);
      }

      .BG_DISH {
        bottom: 0;
        right: 0;
        position: absolute;
        z-index: 7;
        height: calc(100vh * 20 / 100);
        margin-right: 45px;
        margin-bottom: calc(58px * 150 / 100);
      }
    }
  }

  ${Media.lessThan(Media.SIZE.MD)} {
    content: 'Media.lessThan(Media.SIZE.MD)';

    .CHEF {
      max-width: calc(204px * 100 / 100);
      max-height: calc(296px * 120 / 100);
      bottom: 0;
      left: 0;
      margin-left: 10px;
      margin-bottom: calc(58px * 150 / 100);
      position: absolute;
    }

    .BACKGROUND {
      width: initial;
      height: initial;
      bottom: 0;
      left: 0;
      position: relative;

      .BG_LINE {
        bottom: 0;
        left: 0;
        position: absolute;
        z-index: 6;
        object-fit: cover;
      }

      .BG_DISH {
        bottom: 0;
        right: 0;
        position: absolute;
        z-index: 7;
        height: calc(100vh * 20 / 100);
        margin-right: 10px;
        margin-bottom: calc(58px * 150 / 100);
      }
    }
  }
`;

export const DownloadStyled = styled.div`
  display: none;

  ${Media.lessThan(Media.SIZE.LG)} {
    display: flex;
    justify-content: center;
    margin-top: 50px;

    .btn {
      height: max-content;

      img {
        width: 160px;
      }

      &:last-child {
        margin-left: 20px;
      }
    }
  }

  ${Media.lessThan(Media.SIZE.MD)} {
    align-items: flex-start;

    .btn {
      img {
        width: 160px;
      }

      &:last-child {
        margin-left: 20px;
      }
    }
  }
`;

export const OptionStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  img {
    width: 18px;
    border-radius: 100%;
  }
`;
